import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CampaignService } from '../core/data/campaign-service';
import { LayoutTemplate } from '../core/data/layout-template';
import { LayoutTemplateService } from '../core/data/layout-template.service';
import { SettingsService } from '../core/data/settings.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ss-campaign-component',
    templateUrl: './campaign.component.html',
    styles: [
        `
            #flex-container {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
            }

            .flex-item {
                width: 100vw;
                margin: 5px;
                text-align: center;     /* will center text in <p>, which is not a flex item */
            }
        `
    ]
})

export class CampaignComponent {

    /* tslint:disable:no-string-literal */
    vm$ = combineLatest([
        this.campaignService.getCampaignInformation(this.route.snapshot.params['id'] as number),
        this.layoutTemplateService.getLayoutTemplates(),
        this.settingsService.schoolLogoImageURI$
    ]).pipe(
        map(([info, layouts, schoolIconLogo]) => ({
            info,
            layoutType: !layouts ? null : layouts
                .find((x: LayoutTemplate) => x.layoutTemplateId === info?.layoutTemplateId)?.layoutType,
            schoolIconLogo,
            showSchoolIconLogo: schoolIconLogo !== ''
        }))
    );

    constructor(
        private route: ActivatedRoute,
        private campaignService: CampaignService,
        private layoutTemplateService: LayoutTemplateService,
        private settingsService: SettingsService
    ) { }
}
